const id = (value) => encodeURIComponent(value);
export class RecruiterVoiceClient {
    constructor(api) {
        this.api = api;
    }
    setup() {
        return this.api().request('/recruiter/voice/setup', 'GET');
    }
    saveConfig(body) {
        return this.api().request('/recruiter/voice/config', 'PUT', body);
    }
    removeNumber(body) {
        return this.api().request('/recruiter/voice/numbers/remove', 'POST', body);
    }
    searchNumbers(areaCode) {
        return this.api().request(`/recruiter/voice/numbers/search?area_code=${id(areaCode)}`, 'GET');
    }
    buyNumber(body) {
        return this.api().request('/recruiter/voice/numbers/buy', 'POST', body);
    }
    verifyCallerId(body) {
        return this.api().request('/recruiter/voice/caller-id/verify', 'POST', body);
    }
    confirmCallerId() {
        return this.api().request('/recruiter/voice/caller-id/confirm', 'POST', {});
    }
    verifyOwnNumber(body) {
        return this.api().request('/recruiter/voice/own-number/verify', 'POST', body);
    }
    confirmOwnNumber() {
        return this.api().request('/recruiter/voice/own-number/confirm', 'POST', {});
    }
    removeOwnNumber() {
        return this.api().request('/recruiter/voice/own-number/remove', 'POST', {});
    }
    setCallingFrom(body) {
        return this.api().request('/recruiter/voice/calling-from', 'PUT', body);
    }
    phone() {
        return this.api().request('/recruiter/voice/token', 'POST', {});
    }
    savePreferences(preferences) {
        return this.api().request('/recruiter/voice/preferences', 'PUT', preferences);
    }
    async reportProblem(body) {
        await this.api().request('/recruiter/voice/phone-errors', 'POST', body);
    }
    startCall(body) {
        return this.api().request('/recruiter/voice/calls', 'POST', body);
    }
    getCall(callId) {
        return this.api().request(`/recruiter/voice/calls/${id(callId)}`, 'GET');
    }
    cancelCall(callId) {
        return this.api().request(`/recruiter/voice/calls/${id(callId)}/cancel`, 'POST', {});
    }
    logCall(callId, body) {
        return this.api().request(`/recruiter/voice/calls/${id(callId)}/log`, 'POST', body);
    }
    setTranscription(callId, body) {
        return this.api().request(`/recruiter/voice/calls/${id(callId)}/transcription`, 'POST', body);
    }
    setRecording(callId, body) {
        return this.api().request(`/recruiter/voice/calls/${id(callId)}/recording`, 'POST', body);
    }
    transcript(callId, after) {
        return this.api().request(`/recruiter/voice/calls/${id(callId)}/transcript?after=${id(after)}`, 'GET');
    }
    exportCalls(body) {
        return this.api().request('/recruiter/voice/export', 'POST', body);
    }
    exportTranscript(callId, after) {
        return this.api().request(`/recruiter/voice/calls/${id(callId)}/export-transcript?after=${id(after)}`, 'GET');
    }
    candidateCalls(candidateId) {
        return this.api().request(`/recruiter/voice/candidates/${id(candidateId)}/calls`, 'GET');
    }
    async recordingAudio(callId) {
        const api = this.api();
        const res = await fetch(`${api.baseUrl}/recruiter/voice/calls/${id(callId)}/recording`, {
            headers: { Authorization: `Bearer ${api.token}` },
        });
        if (!res.ok)
            throw new Error('The recording couldn\u2019t be loaded. Try again.');
        return res.blob();
    }
}
